import { Box, Card, CardContent, Chip, Container, Grid, Typography } from "@mui/material";
import SentimentVerySatisfiedIcon from "@mui/icons-material/SentimentVerySatisfied";
import HealingIcon from "@mui/icons-material/Healing";
import PeopleIcon from "@mui/icons-material/People";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

const benefitsData = [
  {
    icon: <SentimentVerySatisfiedIcon fontSize="medium" />,
    title: "Fun, not a chore",
    description:
      "Expressive movement, great music, and a room full of energy. Kangoo Jumps turns exercise into the highlight of your week.",
  },
  {
    icon: <HealingIcon fontSize="medium" />,
    title: "Easy on joints, hard on calories",
    description:
      "Rebound shoes absorb up to 80% of impact - so you train with full intensity while protecting your knees, hips, and spine.",
  },
  {
    icon: <AutoAwesomeIcon fontSize="medium" />,
    title: "Anti-aging from the inside out",
    description:
      "Bouncing stimulates the lymphatic system, improves bone density, and supports cellular renewal - benefits traditional cardio can't match.",
  },
  {
    icon: <PeopleIcon fontSize="medium" />,
    title: "A community, not just a class",
    description:
      "A tight-knit group of regulars who show up for each other. Here, you're not anonymous - you're part of something.",
  },
];

export const Benefits = () => (
  <Box
    id="benefits"
    sx={{
      width: "100%",
      backgroundColor: "background.paper",
      py: { xs: 8, sm: 12 },
      px: { xs: 3, sm: 6 },
    }}
  >
    <Container maxWidth="lg">
      <Box sx={{ textAlign: "center", mb: { xs: 6, sm: 8 } }}>
        <Chip
          label="Why Kangoo Jumps?"
          size="small"
          sx={{
            bgcolor: "secondary.main",
            color: "text.primary",
            fontWeight: 700,
            letterSpacing: 0.5,
            mb: 2,
          }}
        />
        <Typography
          component="h2"
          variant="h4"
          sx={{ fontWeight: 900, color: "text.primary" }}
        >
          Not your average workout
        </Typography>
      </Box>

      <Grid container spacing={3} justifyContent="center">
        {benefitsData.map((benefit, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <Card
              elevation={2}
              sx={{
                borderRadius: 3,
                height: "100%",
                display: "flex",
                flexDirection: "column",
                transition: "transform 0.2s, box-shadow 0.2s",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 12px 32px rgba(90,47,158,0.12)",
                },
              }}
            >
              <CardContent sx={{ p: 3, flexGrow: 1 }}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    bgcolor: "teal.main",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "common.white",
                    mb: 2,
                  }}
                >
                  {benefit.icon}
                </Box>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 800, color: "text.primary", mb: 1 }}
                >
                  {benefit.title}
                </Typography>
                <Typography variant="body2" sx={{ color: "text.secondary", lineHeight: 1.7 }}>
                  {benefit.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  </Box>
);
